import { PaginationData, QueryParams } from 'shared/types';
import request from './requesters/client.request';
import { ClientContactPerson } from 'shared/models';

const clientContactPersonService = {
  getContactPersons: (params: QueryParams) =>
    request.get<PaginationData<ClientContactPerson>>('/contact-persons', { params }),
  findContactPerson: (contactPersonId: string | number | undefined, params: QueryParams) =>
    request.get(`/contact-persons/${contactPersonId}`, { params }),
  findContactPersonByParams: (params: QueryParams) => request.get(`/contact-persons`, { params }),
  createContactPerson: (data: ClientContactPerson) =>
    request.post<ClientContactPerson>('/create-contact-persons', data),
  updateContactPerson: (contactPersonId: number, data: ClientContactPerson) =>
    request.put<ClientContactPerson>(`/contact-persons/${contactPersonId}`, data),
  deleteContactPerson: (contactPersonId: number) => request.delete(`/contact-persons/${contactPersonId}`),
};

export default clientContactPersonService;
